var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaimsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F0F2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4284 33.4286C33.4284 33.8832 33.2477 34.3193 32.9263 34.6408C32.6049 34.9622 32.1688 35.1429 31.7141 35.1429H16.2856C15.8309 35.1429 15.3949 34.9622 15.0734 34.6408C14.7519 34.3193 14.5713 33.8832 14.5713 33.4286V14.5715C14.5713 14.1168 14.7519 13.6808 15.0734 13.3593C15.3949 13.0378 15.8309 12.8572 16.2856 12.8572H27.4284L33.4284 18.8572V33.4286Z",
    stroke: "#001184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8046 20.1797C22.3981 20.1797 22.0685 20.5093 22.0685 20.9158V22.9861H19.9983C19.5918 22.9861 19.2622 23.3156 19.2622 23.7222V26.1144C19.2622 26.521 19.5918 26.8505 19.9983 26.8505H22.0685V28.9207C22.0685 29.3273 22.3981 29.6568 22.8046 29.6568H25.1969C25.6034 29.6568 25.933 29.3273 25.933 28.9207V26.8505H28.0032C28.4098 26.8505 28.7393 26.521 28.7393 26.1144V23.7222C28.7393 23.3156 28.4098 22.9861 28.0032 22.9861H25.933V20.9158C25.933 20.5093 25.6034 20.1797 25.1969 20.1797H22.8046Z",
    stroke: "#001184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimsIcon);
export default __webpack_public_path__ + "static/media/claims-icon.30f65cba4c1e76a48fb45a6ea07ff91f.svg";
export { ForwardRef as ReactComponent };